"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _createIconComponent = _interopRequireDefault(require("./utils/createIconComponent"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var IconCaretUp = (0, _createIconComponent["default"])({
  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
    d: "M12.51 48.4a3.85 3.85 0 0 0 5.44 0l17-17 17 17a3.85 3.85 0 0 0 5.45 0 3.85 3.85 0 0 0 0-5.45L35 20.46 12.5 42.94a3.85 3.85 0 0 0 .01 5.46z"
  })),
  height: undefined,
  width: undefined
});
IconCaretUp.displayName = 'IconCaretUp';
var _default = IconCaretUp;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@tecuity/sos-icons/react/caret-up.js
// module id = 92
// module chunks = 0